export default {
  institution: {
    tabs: {
      info: "Allgemeine Informationen",
      general_info: "Allgemeine Informationen",
      stats: "Statistiken",
    },
    list: "Zur Liste der Einrichtungen",
    dashboardLink: "Zum Dashboard der Einrichtung",
    active: "Aktiv",
    archived: "Archiviert",
    training_active: "Aktiv",
    training_archived: "Archiviert",
    view: "Anzeigen",
    view_training: ({ named }) => `Ausbildung ${named("name")} anzeigen`,
    no_trainings: "Keine Ausbildung",
    avatar_alt: ({ named }) => `Logo von ${named("name")}`,
    avatar_initials_alt: ({ named }) => `Initialen von ${named("name")}`,
    fields: {
      logo: "Logo",
      name: "Name",
      siret: "SIRET",
      code_uai: "UAI-Code",
      email: "E-Mail",
      phone: "Telefon",
      address: "Adresse",
      url: "Webseite",
      account_number: "Kontonummer",
      status: "Status",
    },
    components: {
      title: "Komponenten",
    },
    contacts: {
      title: "Kontakte",
      empty: "Kein verknüpfter Kontakt",
      unknown_role: "Kontakt",
      account_active: "Aktives Konto",
      account_inactive: "Inaktives Konto",
    },
    stats: {
      coming_soon: "Demnächst verfügbar",
      export_all_excel: "Alles exportieren — Excel",
      export_in_progress: "Export wird erstellt — Sie werden benachrichtigt, sobald er bereit ist",
      export_failed: "Der Export ist fehlgeschlagen.",
      level: {
        danger: "Niedriges Niveau",
        warning: "Mittleres Niveau",
        success: "Gutes Niveau",
      },
      calculation_note:
        "<strong>Statistikberechnung</strong>: Quoten berechnet auf Basis der veröffentlichten und nicht archivierten Fragebögen." +
        " Ein Trinom ist vollständig, wenn alle 3 Profile (Auszubildender, Tutor, pädagogischer Verantwortlicher) Zugang zum Heft haben.",
      table: {
        caption: "Statistiken nach Ausbildung",
        training: "Ausbildung",
        questionnaires: "Fragebögen",
        skills: "Kompetenzen",
        connections: "Verbindungen",
        triads: "Trinome",
      },
      indicators: {
        questionnaire_fill_rate: "Fragebogenausfüllungsrate",
        skill_fill_rate: "Kompetenzausfüllungsrate",
        user_connection_rate: "Benutzerverbindungsrate",
        completed_triads_rate: "Abgeschlossene Triaden-Rate",
      },
      subcounts: {
        promotions: "Jahrgang/Jahrgänge",
        active_users: "aktive Benutzer",
        triads: "Triade(n)",
      },
    },
    key_figures: {
      title: "Kennzahlen",
      current_year: ({ named }) => `Laufendes Jahr ${named("start")}/${named("end")}`,
      tooltip: "Berechnet auf Basis der Promotionen des laufenden Jahres",
    },
    trainings_count: ({ plural }) => plural(["Ausbildung", "Ausbildungen"]),
    promotions_count: ({ plural }) => plural(["Promotion", "Promotionen"]),
    apprentices_count: ({ plural }) => plural(["Auszubildender", "Auszubildende"]),
    active_trainings_count: ({ plural }) => plural(["aktive Ausbildung", "aktive Ausbildungen"]),
    current_promotions_count: ({ plural }) => plural(["laufende Promotion", "laufende Promotionen"]),
    tutors_count: ({ plural }) => plural(["Unternehmenstutor", "Unternehmenstutoren"]),
  },
};
